import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.69531 4.21094C10.2289 4.21098 10.7409 4.40067 11.1182 4.73828C11.4952 5.07583 11.707 5.53348 11.707 6.01074V14.1992C11.707 14.6766 11.4954 15.135 11.1182 15.4727C10.7409 15.8103 10.2289 16 9.69531 16H2.01172C1.74768 16 1.48614 15.9537 1.24219 15.8633C0.998081 15.7728 0.775698 15.6398 0.588867 15.4727C0.402194 15.3056 0.254384 15.107 0.15332 14.8887C0.0522081 14.6702 -2.05254e-08 14.4357 0 14.1992V6.01074C7.39343e-05 5.53351 0.211879 5.07583 0.588867 4.73828C0.966123 4.4007 1.47821 4.211 2.01172 4.21094H9.69531ZM14.3223 0C14.7668 0.000534885 15.1934 0.17865 15.5078 0.495117C15.8222 0.811757 15.9995 1.24166 16 1.68945V9.97754C15.9989 10.4249 15.8222 10.8539 15.5078 11.1699C15.1934 11.486 14.7665 11.6638 14.3223 11.6641H13.2549V5.36719C13.2533 4.67572 13.0287 3.8569 12.543 3.36816C12.0572 2.87966 11.3496 2.76083 10.6631 2.75977H5.01758V1.68945C5.01811 1.24166 5.19436 0.811757 5.50879 0.495117C5.82321 0.178497 6.24968 0.000537633 6.69434 0H14.3223Z",
		fill: "#7683A8"
	})]
});
const ForwardRef = forwardRef(SvgCopy);
export default ForwardRef;
